import axios from "axios";

export default axios.create({
  baseURL: "https://www.anti-pua-api.com/",
  //   baseURL: "http://45.77.237.63/",
  //baseURL: "https://unihackbackend.herokuapp.com/",
});
